class ProductDetailBanner extends Component {
	constructor(el) {
		super(el);
		this.banners = this.$findAll('.ProductDetailBanner-variant');
		EventBus.getInstance().addEventListener('productVariantChanged', e => this.onVariantChange(e.detail));
	}

	onVariantChange(variant) {
		this.banners.forEach(function (el) {
			el.classList.remove("is-active");
			if (el.dataset.variantId == variant.id) {
				el.classList.add("is-active");
			}
		});
	}
}
